<template>
  <div class="nav" :class="status == 1 ? 'nav--show' : 'nav--hide'">
    <div class="list">
      <div
        v-for="(item, key) in titleList"
        :key="key"
        class="list-item"
      >
        <span @click="scrollTo(item)">{{ item.name }}</span>
      </div>
    </div>
    <div class="control-btn" :class="status == 1 ? 'control-btn--hide' : 'control-btn--show'" @click="changeStatus"></div>
  </div>
</template>

<script>
export default {
  name: 'PcHomeNav',
  data() {
    return {
      status: 1,
      titleList: [
        {
          name: '官网首页',
          height: 0,
        },
        {
          name: '有街头条',
          height: 1020,
        },
        {
          name: '预约奖励',
          height: 2060,
        },
        {
          name: '邀请好友',
          height: 3080,
        },
        {
          name: '名士风采',
          height: 4089,
        },
        {
          name: '游戏特色',
          height: 5322,
        },
        {
          name: '有街社区',
          height: 6314,
        },
      ],
      scrollHeight: '',
      metaHeight: 15,
      metaTime: 10,
      targetHeight: 0,
    }
  },
  computed: {
    stage() {
      return this.$store.getters.stage
    }
  },
  watch: {
    stage: function (val) {
      // 根据当前官网阶段设置标题
      if (val == 1) this.titleList[2].name = '下载有礼'
    }
  },
  methods: {
    scrollTo(titleItem) {
      document.documentElement.scrollTo({
        top: titleItem.height,
        behavior: 'smooth',
      })
    },
    changeStatus() {
      this.status = !this.status
    },
  }
}
</script>

<style lang="scss" scoped>
.nav {
  position: fixed;
  top: 70px;
  width: 188px;
  height: 807px;
  background: url('~@/assets/img/pc/nav_bg.png') no-repeat;
  transition: all .5s ease;

  &--hide {
    right: -188px
  }
  &--show {
    right: 10px;
  }

  .list {
    position: absolute;
    top: 211px;
    width: 100%;

    &-item {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      width: 135px;
      height: 66px;
      font-size: 20px;
      font-family: Noto Serif SC;
      color: #8a4b36;

      span {
        cursor: pointer;

        &:hover {
          color: #388176;
        }
      }
    }
  }

  .control-btn {
    position: absolute;
    bottom: 101px;
    left: -52px;
    width: 42px;
    height: 108px;
    background: url('~@/assets/img/pc/nav_btn.png') no-repeat;
    cursor: pointer;

    &--hide {
      background-position: 0 0;
    }
    &--show {
      background-position: -42px 0;
    }
  }
}
</style>